function initialState() {
    return {
        manufacturer: [],
        articlesNotOnStorage: false,
        priceChangeSince: 0
    };
}

export default {
    state: initialState,
    getters: {},
    mutations: {
        resetFilter(state) {
            const initState = initialState();
            Object.keys(initState).forEach(key => (state[key] = initState[key]));
        },
        setFilterManufacturer(state, manufacturer) {
            state.manufacturer = manufacturer;
        },
        setArticlesNotOnStorage(state, value) {
            console.log(!!value);
            state.articlesNotOnStorage = !!value;
        },
        setPriceChangeSince(state, value) {
            state.priceChangeSince = value;
        }
    },
    actions: {}
};
